(function () {
  'use strict'

  var MODULE_NAME = 'thismoment.common.formly.inputs.country-select'
  var options = require('./countries-data')

  require('angular')
    .module(MODULE_NAME, [])
    .run(countrySelectConfig)

  countrySelectConfig.$inject = ['formlyConfig']
  function countrySelectConfig (formlyConfig) {
    formlyConfig.setType({
      name: 'country-select',
      extends: 'select',
      defaultOptions: {
        defaultValue: 'US',
        templateOptions: {
          options: options
        }
      }
    })
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/formly/inputs/country-select/index.js